class PageRoute {
  static readonly REDIRECT = '/redirect';
  static readonly LOGIN = '/login';
  static readonly LOGOUT = '/logout';
  static readonly NOT_FOUND = '/not-found';
  static readonly SUBSCRIPTION_PLAN = '/subscription-plan/';
  static readonly FREE_TRIAL_REGISTER = '/subscription-plan/free-trial';
  static readonly JOB_BOARD = '/job-board';
  static readonly MARKETPLACE = '/';
  static readonly MARKETPLACE_CART = '/cart';
  static readonly DETAIL = '/detail';
  static readonly PRODUCT_DETAIL = '/product';
  static readonly UNAUTHORIZED = '/unauthorized';
  static readonly PACKAGE_SETTING = '/package/setting';
  static readonly NO_PERMISSION_SUBSCRIPTION = '/no-permission/subscription';
  static readonly NO_PERMISSION_USER = '/no-permission/user';
  static readonly CONSENT = '/consent';
  static readonly UNDER_CONSTRUCTION = '/under-construction';
  static readonly PI = '/pi';
  static readonly MANAGE_CENTER = '/pi/manage-center';
  static readonly AWAIT_VERIFY = '/awaiting-verify';
  static readonly AWAIT_VERIFY_UPGRADE = '/awaiting-verify-upgrade';
  static readonly OFFERING_BOARD = '/pi/offering-board';

  static DEFAULT = PageRoute.MARKETPLACE;
}

export default PageRoute;
export interface RoutesItem<T = any> {
  path: string;
  component: React.FunctionComponent;
  exact: boolean;
  forceDeny?: boolean;
}
export interface BreadcrumbState {
  breadcrumb: { to?: string; title: string }[];
}
